import React from 'react'
import PropTypes from 'prop-types'

import {Flyout, AnimalFlyout, TopBrandsFlyout, SpecialOffersFlyout, CategoryPropType, CATEGORY_TYPES} from './CategoryFlyout.styled'

export class CategoryFlyoutWithoutRef extends React.Component {
  componentDidUpdate() {
    const {forwardedRef, show} = this.props
    if (forwardedRef.current) {
      const all = forwardedRef.current.querySelectorAll('a')
      if (all) {
        const first = all[0]
        const last = all[all.length - 1]
        if (show) {
          first.addEventListener('focusout', this.onBlurFirstItem)
          last.addEventListener('focusout', this.onBlurLastItem)
          document.addEventListener('keyup', this.onEscape)
        } else {
          first.removeEventListener('focusout', this.onBlurFirstItem)
          last.removeEventListener('focusout', this.onBlurLastItem)
          document.removeEventListener('keyup', this.onEscape)
        }
      }
    }
  }

  onBlurFirstItem = async () => {
    const {onBlurFirst} = this.props
    const isContained = await this.activeElementIsContained()
    if (!isContained) {
      onBlurFirst()
    }
  }

  onBlurLastItem = async () => {
    const {onBlurLast} = this.props
    const isContained = await this.activeElementIsContained()
    if (!isContained) {
      onBlurLast()
    }
  }

  activeElementIsContained = () => {
    return new Promise((resolve) => {
      setImmediate(() => {
        const {forwardedRef} = this.props
        if (forwardedRef.current) {
          resolve(forwardedRef.current.contains(document.activeElement))
        }
        resolve(false)
      })
    })
  }

  onEscape = (event) => {
    const {onBlurFirst} = this.props
    if (event.key === 'Escape') {
      onBlurFirst()
    }
  }

  render() {
    const {category, show, forwardedRef, onMouseEnter, onMouseLeave} = this.props
    const {type} = category

    return (
      <Flyout
        ref={forwardedRef}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        show={show}
      >
        {type === CATEGORY_TYPES.ANIMAL
        && <AnimalFlyout category={category} />}

        {type === CATEGORY_TYPES.BRANDS
        && <TopBrandsFlyout category={category} />}

        {type === CATEGORY_TYPES.OFFERS
        && <SpecialOffersFlyout category={category} />}
      </Flyout>
    )
  }
}

CategoryFlyoutWithoutRef.propTypes = {
  category: CategoryPropType.isRequired,
  show: PropTypes.bool.isRequired,
  forwardedRef: PropTypes.shape({current: PropTypes.instanceOf(Element)}).isRequired,
  onMouseEnter: PropTypes.func.isRequired,
  onMouseLeave: PropTypes.func.isRequired,
  onBlurFirst: PropTypes.func.isRequired,
  onBlurLast: PropTypes.func.isRequired
}

export default React.forwardRef((props, ref) => <CategoryFlyoutWithoutRef {...props} forwardedRef={ref} />)
